import BaseDetail from "./Detail";
import BaseList from "./List";
import BaseUrl from "./BaseUrl"; // URL FE List
import Base from "./Base";

export { BaseDetail, BaseList, BaseUrl, Base };
